import React, { useState } from 'react';
import { WidgetContainer } from '@frontend/app/refresh-components';
import { UserGroupIcon } from '@revfluence/fresh-icons/solid/esm';
import { Creators } from './Creators';
import { Posts } from './Posts';

interface RecommendedCreatorsAndPostsProps {
  projectId: number;
}
export const RecommendedCreatorsAndPosts = ({ projectId }: RecommendedCreatorsAndPostsProps) => {
  const [selectedTab] = useState<'Creators' | 'Posts'>('Posts');

  return (
    <WidgetContainer
      widgetTitle="Top Posts"
      textColor="text-grey-6 text-sm"
      bgColor="bg-white"
      widgetIcon={<UserGroupIcon className="text-grey-4" />}
      widgetActions={(
        <>
          {/* <Switcher
            items={[{
              label: 'Creators',
              key: 'Creators',
            }, {
              label: 'Posts',
              key: 'Posts',
            }]}
            type="single"
            activeKeys={[selectedTab]}
            onChange={(keys) => {
              setSelectedTab(keys[0] as 'Creators' | 'Posts');
            }}
          /> */}
        </>
      )}
      className="h-max"
    >
      {selectedTab === 'Creators' && <Creators projectIds={[projectId]} />}
      {selectedTab === 'Posts' && <Posts projectIds={[projectId]} />}
    </WidgetContainer>
  );
};
